module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1276.338d4131.png";